import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = false;

export const openContractSlice = createSlice({
 name: 'openContract',
 initialState,
 reducers: {
  openContract: (state, action: PayloadAction<boolean>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { openContract } = openContractSlice.actions;

export default openContractSlice.reducer;
